import axios from "axios";
import { BankDetailsType } from "../pages/types/BankDetailsType";

export const updateLocalBank = (
  localBankId: number,
  localBankDetails: BankDetailsType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/update/one/tradexwbench.customer_settlement_bank/${localBankId}`,
      {
        params: {
          context: {},
          data: localBankDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
